// @flow
import React, { Component, lazy, Suspense } from "react";

import { LoadingProgress, NoItem } from "imagus-components";
import { getVersion } from "./buildSoftwareJson";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const VersionItem = lazy((): * => import("./VersionItem"));

type VersionListStatesType = {
  expanded: null | boolean | string
};

type VersionListPropsType = {
  versions: Array<*>,
  isAdmin: boolean,
  softwareId: string,
  downloadFile: Function
};

class VersionList extends Component<
  VersionListPropsType,
  VersionListStatesType
> {
  constructor(props: VersionListPropsType) {
    super(props);
    this.state = {
      expanded: null
    };
  }

  handleChange = (panel: string): * => (event: Event, expanded: boolean) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  render(): * {
    const { expanded } = this.state;
    const versions = this.props.versions;

    if (versions.length === 0) {
      return <NoItem content="No Version found." />;
    } else {
      return (
        <div style={{ padding: "15px 10px" }}>
          {versions.map((item: *, i: number): * => {
            let version = getVersion(item);
            return (
              <ExpansionPanel
                expanded={expanded === version.id}
                onChange={this.handleChange(version.id)}
                key={i}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle1" className="heading">
                    <b>Version</b> {version.versionId}
                  </Typography>
                  <Typography variant="subtitle1" className="subheading">
                    <b>Released On</b> {version.releaseDate}
                  </Typography>
                  <Typography variant="subtitle1" className="subheading">
                    {!version.isPublic && (
                      <span className="red-label">Not Released</span>
                    )}
                    {version.isCurrent && (
                      <span className="green-label">Latest</span>
                    )}
                    {version.isBeta && <span className="blue-label">Beta</span>}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Suspense fallback={<LoadingProgress />}>
                    {expanded === version.id && (
                      <VersionItem
                        version={version}
                        isAdmin={this.props.isAdmin}
                        softwareId={this.props.softwareId}
                        downloadFile={this.props.downloadFile}
                      />
                    )}
                  </Suspense>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            );
          })}
        </div>
      );
    }
  }
}

export default VersionList;
